import { defineComponent as _defineComponent } from 'vue';
import moment from 'moment';
import { computed, getCurrentInstance, ref } from 'vue';
import { useActions } from 'vuex-composition-helpers';
import FeedBlogUrlEditDialog from './FeedBlogUrlEditDialog.vue';
import ConfidentialField from './components/ConfidentialField.vue';
import { useFeed } from './utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PropertyDetails',
    setup(__props) {
        const { feed } = useFeed();
        const { patch: patchFeed } = useActions("feed", ["get", "patch"]);
        const showPass = ref(false);
        const editBlogUrl = ref(false);
        const mainPGDatabaseCredentials = {
            host: process.env.VUE_APP_PG_HOST,
            port: process.env.VUE_APP_PG_PORT,
            user: process.env.VUE_APP_PG_USER,
            pass: process.env.VUE_APP_PG_PASSWORD,
            database: process.env.VUE_APP_PG_DATABASE
        };
        const fetcherPGDatabaseCredentials = {
            host: process.env.VUE_APP_FETCH_PG_HOST,
            port: process.env.VUE_APP_FETCH_PG_PORT,
            user: process.env.VUE_APP_FETCH_PG_USER,
            pass: process.env.VUE_APP_FETCH_PG_PASSWORD,
            database: process.env.VUE_APP_FETCH_PG_DATABASE
        };
        const connectionUri = computed(() => {
            let credentials = mainPGDatabaseCredentials;
            if (feed.value?.type === 'fetch-only')
                credentials = fetcherPGDatabaseCredentials;
            return `postgres://${credentials.user}:${credentials.pass}@${credentials.host}:${credentials.port}/${credentials.database}`;
        });
        const instance = getCurrentInstance()?.proxy;
        function copyConnectionUrl() {
            if (!connectionUri.value)
                return;
            navigator.clipboard.writeText(connectionUri.value).then(() => {
                instance?.$toasted.global.success({
                    message: "Connection string was copied to clipboard!",
                });
            });
        }
        async function requestNewToken() {
            if (!feed.value || !feed.value._id)
                return;
            await patchFeed([feed.value._id, {
                    requestTokenReset: true
                }, {}]);
            navigator.clipboard.writeText(feed.value.token).then(() => {
                instance?.$toasted.global.success({
                    message: "Token was copied to clipboard!",
                });
            });
        }
        return { __sfc: true, feed, patchFeed, showPass, editBlogUrl, mainPGDatabaseCredentials, fetcherPGDatabaseCredentials, connectionUri, instance, copyConnectionUrl, requestNewToken, moment, FeedBlogUrlEditDialog, ConfidentialField };
    }
});
